import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Billing } from '../../../models/billing';

import { MatterUserService } from '../../../services/matters/matter-user.service';
import { UserService } from '../../../services/users/user.service';

@Component({
  selector: 'app-matter-user-income',
  templateUrl: './matter-user-income.component.html',
  styleUrls: ['./matter-user-income.component.scss'],
})
export class MatterUserIncomeComponent implements OnInit {
  /**
   * Indicates if page is loading
   * @type {boolean}
   */
  loading: boolean = true;

  /**
   * List of bills - income due
   * @type {Array<Billing>}
   */
  incomeDue: Array<Billing> = [];

  /**
   * Total number of income due bills
   * @type {number}
   */
  incomeDueCount: number = 0;

  /**
   * Id of matter user record
   * @type {number}
   */
  matterUserId: number;

  /**
   * Share of income
   * @type {number}
   */
  shareOfIncome: number = 0;

  /**
   * Income due request params
   * @type {any}
   */
  params: any = {
    page: 1,
    per_page: 15,
  };

  /**
   * Info for current page
   * @type {any}
   */
  userIncomeInfo: any = {};

  /**
   * Constructor
   * @param {ActivatedRoute}    private activatedRoute    Angular service to access current route info and params
   * @param {MatterUserService} private matterUserService Service to access matter users controller
   * @param {UserService}       private userService       Service to access users controller and navbar component
   */
  constructor(private activatedRoute: ActivatedRoute, private matterUserService: MatterUserService, private userService: UserService) {}

  // Component lifecycle methods

  /**
   * Called on component initalization
   */
  ngOnInit() {
    this.userService.navbarComponent.setAccountingMenu();
    if (this.activatedRoute.snapshot.params.id) {
      this.matterUserId = Number(this.activatedRoute.snapshot.params.id);
      this.matterUserService.userIncome(this.matterUserId).then((response_json) => {
        this.userIncomeInfo = response_json;
        if (this.userIncomeInfo.per_page) this.params.per_page = this.userIncomeInfo.per_page;
        this.loadIncomeDue();
      });
      this.matterUserService.shareOfIncome(this.matterUserId).then((response_json) => (this.shareOfIncome = response_json.share_of_income));
    }
  }

  // Component methods

  /**
   * Called to load income due page
   * @param {any = null} pageEvent Page change event (present when page change is done)
   */
  loadIncomeDue(pageEvent: any = null) {
    if (pageEvent) this.params.page = pageEvent.page;
    this.matterUserService.incomeDue(this.matterUserId, this.params).then((response_json) => {
      this.loading = false;
      this.incomeDueCount = response_json.count;
      this.incomeDue = response_json.income_due;
    });
  }
}
